import {
  SparrowBlock,
  Smi2Block,
  Smi24Block
} from '@jtnews/shared/seedwork/frontend/features';

import { Adv, AdvCreative, AdvFlyroll } from '../../../shared/components/_adv';
import { AutoBlock } from '../../../shared/components/auto-block';
import { FeedbackBlock } from '../../../shared/components/feedback-block';
import { ForumsBlock } from '../../../shared/components/forums-block';
import { AuthorRecords } from '../components/author-records';
import { FeedbackError } from '../components/feedback-error';
import { RecordLastNews } from '../components/record-last-news';
import { RelapBlock } from '../components/relap-block';
import { Smi2VideoBlock } from '../components/smi2-video';
import { YandexRecommendedWidget } from '../components/yandex-recommended-widget';
import { RecordBlock } from '../containers';
import { PersonalSelectionAb } from '../containers/ab-personal-selection';
import { AuthorBlock } from '../containers/author-block';
import { BecomeAnAuthor } from '../containers/become-an-author';
import RecordPersonalSelectionABC from '../containers/personal-selection-abc/personal-selection.component.vue';
import RecordPersonalSelection from '../containers/personal-selection/personal-selection.component.vue';
import { RecordCommentsBlock } from '../containers/record-comments-block';
import { RecordRelatedNewsContainer } from '../containers/record-related-news';
import { RecordTags } from '../containers/record-tags';
import { RecordVoting } from '../containers/record-voting';
import { Subscriptions } from '../containers/subscriptions';

export const components = {
  adv: Adv,
  ['adv-creative']: AdvCreative,
  ['author-records']: AuthorRecords,
  ['auto-block']: AutoBlock,
  ['avito-auto']: AutoBlock,
  ['become-an-author']: BecomeAnAuthor,
  ['feedback-block']: FeedbackBlock,
  ['forums-block']: ForumsBlock,
  ['notify-about-typo']: FeedbackError,
  ['record-block']: RecordBlock,
  ['record-comments-block']: RecordCommentsBlock,
  ['record-footer-author']: AuthorBlock,
  ['record-footer-tags']: RecordTags,
  ['record-footer-votes']: RecordVoting,
  ['record-last-news']: RecordLastNews,
  ['record-personal-selection']: RecordPersonalSelection,
  ['similar-records']: RecordRelatedNewsContainer,
  subscriptions: Subscriptions,
  ['smi24-block']: Smi24Block,
  ['relap-block']: RelapBlock,
  ['smi2-block']: Smi2Block,
  ['smi2-video-block']: Smi2VideoBlock,
  ['ab-personal-selection']: PersonalSelectionAb,
  ['sparrow-block']: SparrowBlock,
  ['personal-selection-abc']: RecordPersonalSelectionABC,
  ['yandex-recommended-widget']: YandexRecommendedWidget,
  ['adv-flyroll']: AdvFlyroll
};

export const blockNameToComponentMap = {
  adv: 'adv-creative',
  article: 'record-block',
  ['authors_records']: 'author-records',
  auto: 'auto-block',
  ['avito_auto']: 'avito-auto',
  ['become_an_author']: 'become-an-author',
  comments: 'record-comments-block',
  ['editorial_office']: 'feedback-block',
  ['flyroll_advert']: 'adv-flyroll',
  forum: 'forums-block',
  ['last_news']: 'record-last-news',
  ['notify_about_typo']: 'notify-about-typo',
  ['personal_selection']: 'record-personal-selection',
  ['record_footer_author']: 'record-footer-author',
  ['record_footer_tags']: 'record-footer-tags',
  ['record_footer_votes']: 'record-footer-votes',
  ['similar_records']: 'similar-records',
  ['subscription_block']: 'subscriptions',
  relap: 'relap-block',
  smi2: 'smi2-block',
  ['smi2_video']: 'smi2-video-block',
  smi24: 'smi24-block',
  ['mobile_record_inread_advert']: 'adv-creative',
  ['personal_selection_v3']: 'ab-personal-selection',
  ['sparrow']: 'sparrow-block',
  ['personal_selection_block']: 'personal-selection-abc',
  ['yandex_recommended_widget']: 'yandex-recommended-widget'
};
